import { render, staticRenderFns } from "./CreateTestingSessionButton.vue?vue&type=template&id=4a05e070"
import script from "./CreateTestingSessionButton.vue?vue&type=script&lang=js"
export * from "./CreateTestingSessionButton.vue?vue&type=script&lang=js"
import style0 from "./CreateTestingSessionButton.vue?vue&type=style&index=0&id=4a05e070&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VMenu})
